import { useIntl } from 'react-intl'
import Checkbox from '../checkbox'

const ActionCompare = ({ disabled, added, onChange }) => {
	const { formatMessage } = useIntl()
	return (
		<Checkbox
			checked={added}
			onChange={onChange}
			disabled={disabled}
			name="compare"
			label={added ? formatMessage({ id: 'remove_compare' }) : formatMessage({ id: 'compare' })}
		/>
	)
}

export default ActionCompare
